import resourceStrings from '../../../ResourceStrings';

export type BundleAlertType = 'data' | 'voice';

export function getAlertTypeText(alertType: BundleAlertType) {
  switch (alertType) {
    case 'data':
      return resourceStrings.data;
    case 'voice':
      return resourceStrings.voice;
    default:
      throw new Error('Unknown alert type');
  }
}

export interface BundleAlertBaseDefinitionBase {
  additionalTel: string | null;
  alertLevel: number;
  alertMessage: string | null;
  alertType: BundleAlertType;
  emailBcc: string | null;
  emailCc: string | null;
  emailTo: string | null;
  warningLevel: number;
  warningMessage: string | null;
}

/**
 * An interface representing a bundle alert definition transferrred from the server to the client.
 */
export interface BundleAlertDefinition extends BundleAlertBaseDefinitionBase {
  id: string;
  accountId: number | null;
  provisioningOrderSubscriberId: string | null;
}

/**
 * An interface representing a bundle alert definition transferrred from the server to the client.
 */
export interface BundleAlertConfig extends BundleAlertBaseDefinitionBase {
  accountId: number | null;
  id?: string | null;
}

export interface EditableBundleAlertConfig extends BundleAlertConfig {
  isDeleted?: boolean;
  tel?: string;
}

export function getDefaultBundleAlertConfig(alertType: BundleAlertType) {
  const returnValue: BundleAlertConfig = {
    accountId: null,
    emailTo: null,
    emailCc: null,
    emailBcc: null,
    additionalTel: null,
    alertType,
    warningLevel: 80,
    alertLevel: 100,
    // tslint:disable:max-line-length
    alertMessage:
      'You’ve used {0} of your monthly allowance, it will renew on the 1st of the following month. You will now be charged for any additional usage. To avoid additional charges please contact the support team.',
    warningMessage:
      'You’ve exceeded {0} of your monthly allowance, it will renew on the 1st of the following month. We will let you know when you’ve used 100% after that you will be charged for any additional usage. To increase your allowance please contact the support team.',
    // tslint:enable:max-line-length
  };

  return returnValue;
}

/**
 * An interface representing a bundle alert definition to create on the server.
 */
export interface BundleAlertDefinitionInputCreate extends BundleAlertBaseDefinitionBase {
  accountId?: number | null;
  tel?: string | null;
}

/**
 * An interface representing a bundle alert definition update to be tranferred from the client to the server.
 */
export interface BundleAlertDefinitionInputUpdate {
  id: string;
  additionalTel: string | null;
  alertLevel: number;
  alertMessage: string | null;
  emailTo: string | null;
  emailCc: string | null;
  emailBcc: string | null;
  warningLevel: number;
  warningMessage: string | null;
}

export function getDefaultBundleAlertDefinition(alertType: BundleAlertType) {
  const returnValue: BundleAlertDefinition = {
    id: '',
    accountId: null,
    provisioningOrderSubscriberId: null,
    emailTo: null,
    emailCc: null,
    emailBcc: null,
    additionalTel: null,
    alertType,
    warningLevel: 80,
    alertLevel: 100,
    // tslint:disable:max-line-length
    alertMessage:
      'You’ve used {0} of your monthly allowance, it will renew on the 1st of the following month. You will now be charged for any additional usage. To avoid additional charges please contact the support team.',
    warningMessage:
      'You’ve exceeded {0} of your monthly allowance, it will renew on the 1st of the following month. We will let you know when you’ve used 100% after that you will be charged for any additional usage. To increase your allowance please contact the support team.',
    // tslint:enable:max-line-length
  };

  return returnValue;
}

export const percentInputSettings = {
  min: 0,
  max: 100,
  step: 5,
  precision: 1,
  suffix: '%',
};
